module.exports = __webpack_public_path__ + "img/step3-b.33f6b589.png";